var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#000F30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2398 12.4116L29.8379 19.8959C30.2456 20.1049 30.5032 20.5322 30.5032 20.9997C30.5032 21.4671 30.2456 21.8945 29.8379 22.1034L15.2398 29.5877C14.8168 29.8047 14.309 29.7474 13.9421 29.4413C13.5752 29.1352 13.4171 28.637 13.5381 28.1681L15.3894 20.9997L13.5381 13.8312C13.4171 13.3623 13.5752 12.8641 13.9421 12.558C14.309 12.2519 14.8168 12.1946 15.2398 12.4116Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8818 21.0003H15.3887",
    stroke: "#000F30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.5857fbfaa5d98ccf689aa439f8ed7ded.svg";
export { ForwardRef as ReactComponent };